export type ThemeChoice = 'dark' | 'light' | 'system';

// Its own key, so the old app and this one never read each other's settings during the parallel run.
const storageKey = 'trader-next.theme';

export function readThemeChoice(): ThemeChoice {
  try {
    const stored = window.localStorage.getItem(storageKey);
    return stored === 'light' || stored === 'system' ? stored : 'dark';
  } catch {
    return 'dark';
  }
}

export function resolveTheme(choice: ThemeChoice): 'dark' | 'light' {
  if (choice !== 'system') return choice;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

/** Puts a theme on the page, and on the browser's own bars with the same colours as theme-init.js. */
export function applyTheme(theme: 'dark' | 'light'): void {
  document.documentElement.setAttribute('data-theme', theme);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'light' ? '#f9fafc' : '#0b1015');
}

export function applyThemeChoice(choice: ThemeChoice): void {
  try {
    window.localStorage.setItem(storageKey, choice);
  } catch {
    // Blocked storage only means the choice is not remembered.
  }
  applyTheme(resolveTheme(choice));
}
